function initCustomCarFilter() {
    const $containers = $('.customFilterCategory');

    if (!$containers.length) return;

    /*
     * Kliknutí mimo filtr zavře všechny selecty.
     */
    $(document)
        .off('click.customCarFilter')
        .on('click.customCarFilter', function () {
            $('.customFilterCategory .customOptions').hide();

            $('.customFilterCategory .customSelectDisplay')
                .attr('aria-expanded', 'false');
        });

    $containers.each(function () {
        const $container = $(this);

        /*
         * Hodnoty musíme načíst před $container.empty().
         */
        const firstUrl = $container.attr('data-link');

        const config = {
            type: {
                label:
                    $container.attr('data-type-label') ||
                    'Typ auta',

                placeholder:
                    $container.attr('data-type-placeholder') ||
                    'Např. osobní automobil'
            },

            brand: {
                label:
                    $container.attr('data-brand-label') ||
                    'Značka auta',

                placeholder:
                    $container.attr('data-brand-placeholder') ||
                    'Např. Volkswagen'
            },

            model: {
                label:
                    $container.attr('data-model-label') ||
                    'Model auta',

                placeholder:
                    $container.attr('data-model-placeholder') ||
                    'Např. Passat'
            },

            year: {
                label:
                    $container.attr('data-year-label') ||
                    'Rok výroby',

                placeholder:
                    $container.attr('data-year-placeholder') ||
                    'Např. 2025'
            },

            buttonText:
                $container.attr('data-button-text') ||
                'Zobrazit autodoplňky'
        };

        /*
         * Ukončení požadavků z předchozí inicializace.
         */
        const previousState =
            $container.data('customCarFilterState');

        if (previousState && previousState.requests) {
            previousState.requests.forEach(function (request) {
                if (request && request.readyState !== 4) {
                    request.abort();
                }
            });
        }

        const state = {
            currentTargetUrl: null,
            requests: [],

            requestVersion: {
                types: 0,
                brands: 0,
                models: 0,
                years: 0
            }
        };

        $container
            .data('customCarFilterState', state)
            .empty();

        if (!firstUrl) {
            console.warn(
                'Custom car filter: chybí atribut data-link.',
                $container[0]
            );

            return;
        }

        /* =========================
           HELPERS
        ========================= */

        function registerRequest(request) {
            state.requests.push(request);

            request.always(function () {
                state.requests = state.requests.filter(
                    function (item) {
                        return item !== request;
                    }
                );
            });

            return request;
        }

        function createCustomSelect(
            labelText,
            placeholder
        ) {
            const $wrapper = $('<div>', {
                class: 'customSelectWrapper'
            });

            const $label = $('<label>').text(labelText);

            const $display = $('<div>', {
                class: 'customSelectDisplay',
                role: 'button',
                tabindex: 0,
                'aria-expanded': 'false',
                'aria-disabled': 'false'
            });

            const $selectedLabel = $('<span>', {
                class: 'selected-label'
            }).text(placeholder);

            const $arrow = $('<span>', {
                class: 'customSelectArrow',
                'aria-hidden': 'true'
            }).text('▼');

            const $options = $('<div>', {
                class: 'customOptions',
                role: 'listbox'
            }).hide();

            $display.append(
                $selectedLabel,
                $arrow
            );

            $wrapper.append(
                $label,
                $display,
                $options
            );

            return {
                $wrapper: $wrapper,
                $display: $display,
                $options: $options,
                placeholder: placeholder
            };
        }

        function setSelectDisabled(
            selectObj,
            disabled
        ) {
            selectObj.$wrapper
                .toggleClass('disabled', disabled)
                .css({
                    opacity: disabled ? 0.6 : 1,
                    pointerEvents: disabled
                        ? 'none'
                        : 'auto'
                });

            selectObj.$display.attr(
                'aria-disabled',
                disabled ? 'true' : 'false'
            );

            if (disabled) {
                selectObj.$options.hide();

                selectObj.$display.attr(
                    'aria-expanded',
                    'false'
                );
            }
        }

        function setButtonEnabled(enabled) {
            $filterWrap
                .toggleClass('disabled', !enabled)
                .css({
                    opacity: enabled ? 1 : 0.6,
                    pointerEvents: enabled
                        ? 'auto'
                        : 'none'
                });

            $filterBtn.prop(
                'disabled',
                !enabled
            );
        }

        function setTargetUrl(url) {
            state.currentTargetUrl = url || null;

            setButtonEnabled(
                Boolean(state.currentTargetUrl)
            );
        }

        function resetSelect(
            selectObj,
            placeholder,
            disabled
        ) {
            if (typeof disabled === 'undefined') {
                disabled = true;
            }

            selectObj.$display
                .find('.selected-label')
                .replaceWith(
                    $('<span>', {
                        class: 'selected-label'
                    }).text(placeholder)
                );

            selectObj.$display.attr(
                'aria-expanded',
                'false'
            );

            selectObj.$options
                .empty()
                .hide();

            setSelectDisabled(
                selectObj,
                disabled
            );
        }

        function createOption(item) {
            const $option = $('<div>', {
                class: 'customOption',
                role: 'option',
                tabindex: 0,
                'aria-selected': 'false'
            }).data({
                name: item.name,
                img: item.img || null,
                href: item.href
            });

            if (item.img) {
                $option.append(
                    $('<img>', {
                        src: item.img,
                        alt: '',
                        loading: 'lazy'
                    })
                );
            }

            $option.append(
                $('<span>').text(item.name)
            );

            return $option;
        }

        function fillOptions(selectObj, items) {
            const fragment =
                document.createDocumentFragment();

            items.forEach(function (item) {
                fragment.appendChild(
                    createOption(item)[0]
                );
            });

            selectObj.$options
                .empty()
                .append(fragment);
        }

        function setSelectedValue(
            selectObj,
            item
        ) {
            const $selectedLabel = $('<span>', {
                class: 'selected-label'
            });

            if (item.img) {
                $selectedLabel.append(
                    $('<img>', {
                        src: item.img,
                        alt: ''
                    })
                );
            }

            $selectedLabel.append(
                $('<span>').text(item.name)
            );

            selectObj.$display
                .find('.selected-label')
                .replaceWith($selectedLabel);
        }

        function bindCustomSelect(
            selectObj,
            onSelect
        ) {
            selectObj.$display
                .off('.customCarFilter')
                .on(
                    'click.customCarFilter',
                    function (event) {
                        event.stopPropagation();

                        if (
                            selectObj.$wrapper.hasClass(
                                'disabled'
                            )
                        ) {
                            return;
                        }

                        const shouldOpen =
                            !selectObj.$options.is(
                                ':visible'
                            );

                        $container
                            .find('.customOptions')
                            .not(selectObj.$options)
                            .hide()
                            .prev(
                                '.customSelectDisplay'
                            )
                            .attr(
                                'aria-expanded',
                                'false'
                            );

                        selectObj.$options.toggle(
                            shouldOpen
                        );

                        selectObj.$display.attr(
                            'aria-expanded',
                            shouldOpen
                                ? 'true'
                                : 'false'
                        );
                    }
                )
                .on(
                    'keydown.customCarFilter',
                    function (event) {
                        if (
                            event.key !== 'Enter' &&
                            event.key !== ' '
                        ) {
                            return;
                        }

                        event.preventDefault();

                        selectObj.$display.trigger(
                            'click'
                        );
                    }
                );

            selectObj.$options
                .off('.customCarFilter')
                .on(
                    'click.customCarFilter',
                    '.customOption',
                    function (event) {
                        event.stopPropagation();

                        selectOption($(this));
                    }
                )
                .on(
                    'keydown.customCarFilter',
                    '.customOption',
                    function (event) {
                        if (
                            event.key !== 'Enter' &&
                            event.key !== ' '
                        ) {
                            return;
                        }

                        event.preventDefault();

                        selectOption($(this));
                    }
                );

            function selectOption($option) {
                selectObj.$options
                    .find('.customOption')
                    .removeClass('selected')
                    .attr(
                        'aria-selected',
                        'false'
                    );

                $option
                    .addClass('selected')
                    .attr(
                        'aria-selected',
                        'true'
                    );

                const selectedItem = {
                    name: $option.data('name'),
                    img: $option.data('img'),
                    href: $option.data('href')
                };

                setSelectedValue(
                    selectObj,
                    selectedItem
                );

                selectObj.$options.hide();

                selectObj.$display.attr(
                    'aria-expanded',
                    'false'
                );

                if (
                    typeof onSelect ===
                    'function'
                ) {
                    onSelect(selectedItem);
                }
            }
        }

        /*
         * Vybere jednotlivé LI z prvního UL.subcategories.
         */
        function getSubcategoryItems(data) {
            const $html = $(data);

            return $html
                .find('ul.subcategories')
                .first()
                .children('li');
        }

        function parseSubcategoryItems(
            $items,
            includeImage
        ) {
            const items = [];

            $items.each(function () {
                const $link = $(this)
                    .children('a')
                    .first();

                const name = $.trim(
                    $link
                        .find('.text')
                        .first()
                        .text()
                );

                const href =
                    $link.attr('href');

                if (!name || !href) {
                    return;
                }

                items.push({
                    name: name,

                    img: includeImage
                        ? getRealImage(
                            $link
                                .find('img')
                                .first()
                        )
                        : null,

                    href: href
                });
            });

            return items;
        }

        function loadSubcategories(
            url,
            requestType,
            includeImage,
            callback
        ) {
            state.requestVersion[requestType]++;

            const currentVersion =
                state.requestVersion[requestType];

            const request = $.ajax({
                url: url,
                method: 'GET',
                dataType: 'html'
            })
                .done(function (data) {
                    /*
                     * Ignoruje starou AJAX odpověď,
                     * pokud mezitím proběhl nový výběr.
                     */
                    if (
                        currentVersion !==
                        state.requestVersion[
                            requestType
                        ]
                    ) {
                        return;
                    }

                    const $subcategories =
                        getSubcategoryItems(data);

                    const items =
                        parseSubcategoryItems(
                            $subcategories,
                            includeImage
                        );

                    callback(items);
                })
                .fail(function (
                    xhr,
                    status
                ) {
                    if (status === 'abort') {
                        return;
                    }

                    console.error(
                        'Custom car filter: nepodařilo se načíst URL:',
                        url
                    );
                });

            registerRequest(request);
        }

        /* =========================
           BUTTON
        ========================= */

        const $filterBtn = $('<button>', {
            class: 'btn btn-primary',
            type: 'button',
            text: config.buttonText,
            disabled: true
        });

        const $filterWrap = $('<div>', {
            class:
                'customSelectWrapper buttonWrap disabled'
        }).css({
            opacity: 0.6,
            pointerEvents: 'none'
        });

        $filterWrap.append($filterBtn);
        $container.append($filterWrap);

        $filterBtn
            .off('click.customCarFilter')
            .on(
                'click.customCarFilter',
                function () {
                    if (
                        !state.currentTargetUrl
                    ) {
                        return;
                    }

                    window.location.href =
                        state.currentTargetUrl;
                }
            );

        /* =========================
           SELECTS
        ========================= */

        const typeSelect = createCustomSelect(
            config.type.label,
            config.type.placeholder
        );

        const brandSelect = createCustomSelect(
            config.brand.label,
            config.brand.placeholder
        );

        const modelSelect = createCustomSelect(
            config.model.label,
            config.model.placeholder
        );

        const yearSelect = createCustomSelect(
            config.year.label,
            config.year.placeholder
        );

        /*
         * Na začátku je aktivní pouze první select.
         */
        setSelectDisabled(
            typeSelect,
            false
        );

        setSelectDisabled(
            brandSelect,
            true
        );

        setSelectDisabled(
            modelSelect,
            true
        );

        setSelectDisabled(
            yearSelect,
            true
        );

        $container.append(
            typeSelect.$wrapper,
            brandSelect.$wrapper,
            modelSelect.$wrapper,
            yearSelect.$wrapper
        );

        /* =========================
           TYPE SELECT
        ========================= */

        bindCustomSelect(
            typeSelect,
            function (type) {
                /*
                 * Zneplatnění starších požadavků.
                 */
                state.requestVersion.brands++;
                state.requestVersion.models++;
                state.requestVersion.years++;

                setTargetUrl(type.href);

                resetSelect(
                    brandSelect,
                    config.brand.placeholder,
                    true
                );

                resetSelect(
                    modelSelect,
                    config.model.placeholder,
                    true
                );

                resetSelect(
                    yearSelect,
                    config.year.placeholder,
                    true
                );

                loadSubcategories(
                    type.href,
                    'brands',
                    true,
                    function (brands) {
                        fillOptions(
                            brandSelect,
                            brands
                        );

                        setSelectDisabled(
                            brandSelect,
                            brands.length === 0
                        );
                    }
                );
            }
        );

        /* =========================
           BRAND SELECT
        ========================= */

        bindCustomSelect(
            brandSelect,
            function (brand) {
                state.requestVersion.models++;
                state.requestVersion.years++;

                setTargetUrl(brand.href);

                resetSelect(
                    modelSelect,
                    config.model.placeholder,
                    true
                );

                resetSelect(
                    yearSelect,
                    config.year.placeholder,
                    true
                );

                loadSubcategories(
                    brand.href,
                    'models',
                    true,
                    function (models) {
                        fillOptions(
                            modelSelect,
                            models
                        );

                        setSelectDisabled(
                            modelSelect,
                            models.length === 0
                        );
                    }
                );
            }
        );

        /* =========================
           MODEL SELECT
        ========================= */

        bindCustomSelect(
            modelSelect,
            function (model) {
                state.requestVersion.years++;

                setTargetUrl(model.href);

                resetSelect(
                    yearSelect,
                    config.year.placeholder,
                    true
                );

                loadSubcategories(
                    model.href,
                    'years',
                    false,
                    function (years) {
                        fillOptions(
                            yearSelect,
                            years
                        );

                        setSelectDisabled(
                            yearSelect,
                            years.length === 0
                        );
                    }
                );
            }
        );

        /* =========================
           YEAR SELECT
        ========================= */

        bindCustomSelect(
            yearSelect,
            function (year) {
                setTargetUrl(year.href);
            }
        );

        /* =========================
           LOAD FIRST LEVEL
        ========================= */

        loadSubcategories(
            firstUrl,
            'types',
            true,
            function (types) {
                fillOptions(
                    typeSelect,
                    types
                );

                setSelectDisabled(
                    typeSelect,
                    types.length === 0
                );
            }
        );
    });
}

function getRealImage($img) {
    if (!$img.length) {
        return null;
    }

    const imageUrl =
        $img.attr('data-src') ||
        $img.attr('data-lazy') ||
        $img.attr('data-original') ||
        $img.attr('src');

    if (!imageUrl) {
        return null;
    }

    /*
     * Ignoruje inline placeholder.
     */
    if (
        imageUrl.indexOf('data:image/') === 0
    ) {
        return null;
    }

    return imageUrl;
}

$(function () {
    initCustomCarFilter();
});

$(document)
    .off(
        'ShoptetDOMPageContentLoaded.customCarFilter'
    )
    .on(
        'ShoptetDOMPageContentLoaded.customCarFilter',
        function () {
            initCustomCarFilter();
        }
    );